// extracted by mini-css-extract-plugin
export default {"profileWindow":"ProfileWindow_profileWindow__FsEDe","leftSidePanel":"ProfileWindow_leftSidePanel__cfWXA","rightTabPanel":"ProfileWindow_rightTabPanel__T+oR3"};